import { t } from "../internals/typed-array-constructor.js";
t("Float64", function (t) {
  return function (r, n, o) {
    return t(this, r, n, o);
  };
});